import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { Button, Typography } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { StyledNte } from "../../../styled/Prevencion";

const ImportarNominaOkContainer = ({ handleSubmit }) => {
  const theme = useTheme();

  return (
    <>
      <StyledNte.LoadingContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            style={{ color: `${theme.palette.secondary.light}` }}
          >
            Recibido
          </Typography>
          <TaskAltIcon
            style={{ color: `${theme.palette.secondary.light}` }}
            fontSize="large"
          />
          <Button
            color="primary"
            variant="contained"
            onClick={handleSubmit}
            style={{ marginTop: 20 }}
          >
            Siguiente
          </Button>
        </div>
      </StyledNte.LoadingContainer>
    </>
  );
};

export default ImportarNominaOkContainer;
